module.exports = __webpack_public_path__ + "img/item_2.6b9b6eac.png";